import React from 'react'
import axios from 'axios';
import { Snackbar, SnackbarContent, Button } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Modal from '@material-ui/core/Modal';
import { Redirect } from "react-router-dom";



import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import Matrix from 'scripts/Matrix'
import style from 'style/consult/ConsultRequests.css'
import ConsultRequestItem from 'components/consult/ConsultRequestItem'
import utils from '../../Utils'

class ConstultRequests extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      consultRequests: [],
      openModal: false,
      consultRequestIdModal: 0,
      modalLoading: false,
      redirectToChatRoom: ''
    }
  }

  async componentDidMount() {
    this.fetchConsultRequest(0)
  }

  fetchConsultRequest = async (offset = 0) => {
    this.setState({ loading: true })

    let result = await axios.post(utils.urls.consultRequests, { offset }, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result)
    let { consultRequests } = result.data;
    if (!consultRequests) return this.SnackBar.openSnackbar("خطایی رخ داده است")
    this.setState({ consultRequests: consultRequests })


  }

  showModal = (consultRequestId) => {
    this.setState({ consultRequestIdModal: consultRequestId, openModal: true })
  }
  acceptRequest = async () => {
    this.setState({ modalLoading: true })
    // console.log('accepted', this.state.consultRequestIdModal)

    let result = await axios.post(
      utils.urls.assignConsultRequestURL,
      { questionId: this.state.consultRequestIdModal },
      {
        headers: {
          'x-access-token': Matrix.getToken()
        }
      }
    ).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    // console.log(result)
    this.setState({ consultRequestIdModal: 0, openModal: false })
    this.setState({ modalLoading: false })
    let { consultRequest } = result.data
    const roomId = consultRequest.roomId
    if (roomId) {
      this.setState({redirectToChatRoom:roomId})
    }

  }

  handleClose = () => {
    this.setState({ consultRequestIdModal: 0, openModal: false })
  }

  render() {
    if (this.state.redirectToChatRoom) {
      // console.log(this.state.redirectToChatRoom+'------------')
      return <Redirect to={`/chat/${this.state.redirectToChatRoom}`} />
    }
    return (
      <React.Fragment>
        <Header title="طبینجا" showBackButton={false}/>
        <div class="consult-requests-container">
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
          {this.state.consultRequests.map(consult =>
            <ConsultRequestItem key={consult.id} consultRequest={consult} showModalCallBack={this.showModal}></ConsultRequestItem>
          )}
          {this.state.loading && <div class="Loading"><Loading /></div>}
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.consultRequestIdModal!==0 && this.state.openModal}
            onClose={this.handleClose}
          >
            <div class="modalAccept">
              <h2 id="simple-modal-title">پذیرش بیمار</h2>
              <p id="simple-modal-description">
                آیا از پذیرش بیمار اطمینان دارید؟ شما بعد از پذیرش مسئول پاسخگویی به وی خواهید بود
              </p>
              <div class="modal-action">
                {this.state.modalLoading && this.state.openModal && this.state.consultRequestIdModal && <div class="Loading"><Loading /></div>}
                <Button onClick={this.handleClose}>خیر</Button>
                <Button className='primary-action' onClick={this.acceptRequest}>بله</Button>
              </div>
            </div>
          </Modal>
        </div>
        <BottomNavigation selected='1' />
      </React.Fragment>
    )
  }
}
export default ConstultRequests;